/* prevent redeclaration if script loads multiple times */
if (!window.SellingPlansWidget) {
const hiddenClass = window.hiddenClass || 'selling_plan_theme_integration--hidden';
window.hiddenClass = hiddenClass;

window.SellingPlansWidget = class SellingPlansWidget {

  constructor(sellingPlansWidgetContainer) {
    if (!sellingPlansWidgetContainer) return;
    this.sellingPlansWidgetContainer = sellingPlansWidgetContainer;

    try {
      this.enablePerformanceObserver();
      this.appendSellingPlanInputs();
      this.updateSellingPlanInputsValues();
      this.listenToVariantChange();
      this.listenToSellingPlanFormRadioButtonChange();
      this.selectFirstSellingPlan();
      this.updatePrice();
    } catch (error) {
      console.warn('SellingPlansWidget init error', error);
    }
  }

  get sectionId() {
    return this.sellingPlansWidgetContainer?.getAttribute('data-section-id');
  }

  get shopifySection() {
    return document.querySelector(`#shopify-section-${this.sectionId}`);
  }

  get variantIdInput() {
    if (!this.addToCartForms?.length) return null;
    return (
      this.addToCartForms[1]?.querySelector(`input[name="id"]`) ||
      this.addToCartForms[1]?.querySelector(`select[name="id"]`) ||
      this.addToCartForms[0]?.querySelector(`input[name="id"]`) ||
      this.addToCartForms[0]?.querySelector(`select[name="id"]`)
    );
  }

  get addToCartForms() {
    return this.shopifySection?.querySelectorAll('[action*="/cart/add"]') || [];
  }

  get priceElement() {
    return this.shopifySection?.querySelector('.price');
  }

  get comparedAtPrice() {
    return this.shopifySection?.querySelector('.price__sale');
  }

  get visibleSellingPlanForm() {
    if (!this.variantIdInput) return null;
    return this.shopifySection?.querySelector(
      `section[data-variant-id^="${this.variantIdInput.value}"]`
    );
  }

  get sellingPlanInput() {
    return this.shopifySection?.querySelector('.selected-selling-plan-id');
  }

  get sellingPlanInputs() {
    return this.shopifySection?.querySelectorAll('.selected-selling-plan-id') || [];
  }

  get sellingPlanRadioInputs() {
    return this.shopifySection?.querySelectorAll('.appstle_input_wrapper input[type="radio"][name="selling_plan"]') || [];
  }

  appendSellingPlanInputs() {
    if (!this.sellingPlanInput) return;
    this.addToCartForms.forEach((form) => {
      form.appendChild(this.sellingPlanInput.cloneNode());
    });
  }

  showSellingPlanForm(form) {
    form?.classList?.remove(hiddenClass);
  }

  hideSellingPlanForms(forms) {
    forms?.forEach((el) => el.classList.add(hiddenClass));
  }

  handleSellingPlanFormVisibility() {

    if (!this.variantIdInput) return;
    const selectedForm = this.shopifySection?.querySelector(
      `section[data-variant-id="${this.variantIdInput.value}"]`
    );
    const otherForms = this.shopifySection?.querySelectorAll(
      `.selling_plan_theme_integration:not([data-variant-id="${this.variantIdInput.value}"])`
    );
    this.showSellingPlanForm(selectedForm);
    this.hideSellingPlanForms(otherForms);
  }

  handleVariantChange() {
    this.handleSellingPlanFormVisibility();
    this.updateSellingPlanInputsValues();
    this.listenToSellingPlanFormRadioButtonChange();
  }

  listenToVariantChange() {

    if (!this.variantIdInput) return;
    this.listenToAddToCartForms();
    if (this.variantIdInput.tagName === 'INPUT') {
      const observer = new MutationObserver(() => {
        this.handleVariantChange();
      });
      observer.observe(this.variantIdInput, {
        attributes: true
      });
    }
  }

  listenToAddToCartForms() {
    this.addToCartForms.forEach((form) => {
      form.addEventListener('change', () => {
        this.handleVariantChange();
      });
      form.addEventListener('submit', () => {
        this.updateSellingPlanInputsValues();
      }, true);
    });
  }

  get regularPriceElement() {
    return this.shopifySection?.querySelector('.price__regular');
  }

  get salePriceElement() {
    return this.shopifySection?.querySelector('.price__sale');
  }

  get salePriceValue() {
    return this.salePriceElement?.querySelector('.price-item--sale');
  }

  get regularPriceValue() {
    return this.salePriceElement?.querySelector('.price-item--regular');
  }

  get selectedPurchaseOption() {
    return this.visibleSellingPlanForm?.querySelector('input[type="radio"]:checked');
  }

  set selectedPurchaseOption(option) {
    this._selectedPurchaseOption = option;
  }

  get sellingPlanInputValue() {
    return this.selectedPurchaseOption?.dataset?.sellingPlanId ?? "";
  }

  get selectedPurchaseOptionPrice() {
    return this.selectedPurchaseOption?.dataset?.variantPrice;
  }

  get selectedPurchaseOptionComparedAtPrice() {
    return this.selectedPurchaseOption?.dataset?.variantCompareAtPrice;
  }

  updateSellingPlanInputsValues() {
    const value = this.sellingPlanInputValue || "";
    this.sellingPlanInputs.forEach((input) => {
      input.value = value;
    });
    this.sellingPlanRadioInputs.forEach((radio) => {
      const radioValue = radio.value || "";
      radio.checked = radioValue === value;
    });
  }

  updatePrice() {

    if (!this.selectedPurchaseOption) return;
    const compare = this.selectedPurchaseOptionComparedAtPrice;
    const price = this.selectedPurchaseOptionPrice;
    if (!compare || compare === price) {
      this.showRegularPrice();
      this.hideSalePrice();
      this.priceElement?.classList.remove('price--on-sale');
    } else {
      this.showSalePrice();
      this.hideRegularPrice();
      this.priceElement?.classList.add('price--on-sale');
    }
  }

  hideSalePrice() {
    if (this.salePriceElement) this.salePriceElement.style.display = 'none';
  }

  hideRegularPrice() {
    if (this.regularPriceElement) this.regularPriceElement.style.display = 'none';
  }

  showRegularPrice() {
    if (this.regularPriceElement){
      this.regularPriceElement.style.display = 'block';
    }
    this.shopifySection?.querySelector('.price__sale')?.style.setProperty('display','none');
  }

  showSalePrice() {
    if (!this.salePriceElement) return;
    this.salePriceElement.style.display = 'block';
    if (this.regularPriceValue)
      this.regularPriceValue.innerHTML = this.selectedPurchaseOptionComparedAtPrice;

    if (this.salePriceValue)
      this.salePriceValue.innerHTML = this.selectedPurchaseOptionPrice;
  }

  handleRadioButtonChange(option) {
    this.selectedPurchaseOption = option;
    this.updateSellingPlanInputsValues();
    this.updatePrice();
    const qtyInput = document.querySelector('.subscription_quantity__input');
     if (option && option.dataset && option.dataset.qty && qtyInput) {
        qtyInput.value = option.dataset.qty;
      }else{
        if(qtyInput){
          qtyInput.value = 1;
        }
      }
  }

  listenToSellingPlanFormRadioButtonChange() {
    this.visibleSellingPlanForm
      ?.querySelectorAll('input[type="radio"]')
      ?.forEach((radio) => {
        radio.addEventListener('change', (event) => {
          this.handleRadioButtonChange(event.target);
        });
      });
  }

    selectFirstSellingPlan() {
      const form = this.visibleSellingPlanForm;
      if (!form) return;

      const monthlyRadio = form.querySelector('.monthly-plan-card input[type="radio"], input[data-radio-type="selling_plan"][data-qty="1"]');
      const firstRadio = form.querySelector('.plan-card input[type="radio"]');
      const defaultRadio = monthlyRadio || firstRadio;

      if (!defaultRadio) return;

      form.querySelectorAll('.plan-card input[type="radio"]').forEach((radio) => {
        radio.checked = false;
      });

      defaultRadio.checked = true;
      this.handleRadioButtonChange(defaultRadio);
    }

  enablePerformanceObserver() {
    if (!window.PerformanceObserver) return;
    const observer = new PerformanceObserver((list) => {
      list.getEntries().forEach((entry) => {
        if (entry.initiatorType !== 'fetch') return;
        const url = new URL(entry.name);
        if (url.search.includes('variant') || url.search.includes('variants')) {
          this.updatePrice();
        }
      });
    });
    observer.observe({ entryTypes: ['resource'] });
  }

};

}

/* now initialize widgets safely for multiple sections */
document
  .querySelectorAll('.selling_plan_app_container')
  .forEach((container) => {
    if (container.dataset.sellingPlanInitialized === "true") return;
    container.dataset.sellingPlanInitialized = "true";
    new window.SellingPlansWidget(container);
  });